import KoioteOmronConnection from "./KoioteOmronConnection.vue";
import KoioteOmronConnectionProperties from "./KoioteOmronConnectionProperties.vue";
import KoioteOmronConnectionProperty from "./default.json";

export default {
  install(Vue) {
    Vue.component(KoioteOmronConnection.name, KoioteOmronConnection);
    Vue.component(KoioteOmronConnectionProperties.name, KoioteOmronConnectionProperties);
    Vue.prototype.$OmronConnectionProperties = KoioteOmronConnectionProperty;
  },
};
